module.exports = __webpack_public_path__ + "static/media/sellue.82eaf60e.png";